<div class="container-fluid">

  <div class="drag-drop-explanation">{{ 'bikeshop.rentals.products.drag_product_explanation' | translate }} </div>
  <div class="row">
    <div class="col-md-4">
      <div class="content">
        <div class="column-header">{{ 'bikeshop.rentals.products.available_products' | translate }}</div>
        <div *ngIf="loadingProducts"
             style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
          </p-progressSpinner>
        </div>
        <div class="product-container" *ngFor="let category of productCategories; let i = index">
          <div class="category-name" [ngClass]="{'margin-top-16': i > 0 }">{{category.categoryName}}</div>
          <div id="productList" cdkDropList [cdkDropListData]="category.products"
               [cdkDropListConnectedTo]="connectedAccessories">
            <div *ngFor="let product of category.products;" cdkDrag [cdkDragData]="product">
              <div class="product-item">
                <span class="hubtiger-dragdrop"></span>
                <div class="image" [ngStyle]="{'background-image': 'url('+product.imageURL+')'}"></div>
                <div class="title">{{product.brand}} {{product.model}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="content">
        <div class="column-header">{{ 'bikeshop.rentals.products.linkable_accessories' | translate }}</div>
        <div *ngIf="loadingAccessories"
             style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
          </p-progressSpinner>
        </div>
        <div class="error" *ngIf="!loadingAccessories && accessories && accessories.length === 0">{{
          'bikeshop.rentals.products.no_linkable_accessories' | translate }}</div>
        <div *ngFor="let accessory of accessories; let i = index">
          <div class="category-name" [ngClass]="{'margin-top-16': i > 0 }"
               *ngIf="i === 0 || (i > 0 && accessory.accessoryCategoryName !== accessories[i-1].accessoryCategoryName)">
            {{accessory.accessoryCategoryName}}</div>
          <div class="accessory-header">
            <div class="image" [ngStyle]="{'background-image': 'url('+accessory.imageURL+')'}"></div>
            <div>{{accessory.brand}} {{accessory.name}}</div>
          </div>
          <div class="accessory-drop-container">
            <div *ngIf="accessory.linkingProducts" style="display: flex;justify-content: center;">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
            <div>
              <div class="product-container" id="{{accessory.brand + '_'+accessory.name}}" cdkDropList
                   (cdkDropListDropped)="dropAccessory($event, accessory)" cdkDropListOrientation="horizontal"
                   [cdkDropListData]="accessory.linkedProducts">
                <div *ngFor="let product of accessory.linkedProducts" class="product-item">
                  <div class="image" [ngStyle]="{'background-image': 'url('+ product.imageURL +')'}"></div>
                  <div class="title">{{product.brand}} {{product.model}}</div>
                  <div class="remove-action"><span (click)="removeProduct(accessory, product)"
                                                   class="fa fa-times"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="drag-drop-hint" *ngIf="accessory.linkedProducts.length === 0 && !accessory.linkingProducts">{{
              'bikeshop.rentals.products.drag_product_here_to_link' | translate }}</div>
            <div class="buttons-container"
                 *ngIf="!loadingProducts && !accessory.linkingProducts && products.length !== accessory.linkedProducts.length">
              <div class="button" (click)="linkAllProducts(accessory, i)">{{
                'bikeshop.rentals.products.link_all_products' | translate }}</div>
              <div *ngFor="let productCategory of productCategories"
                   (click)="linkCategory(accessory, i, productCategory.categoryName)" class="button">
                {{productCategory.categoryName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
